import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {isNullOrUndefined} from 'util';
import {AliyunService} from '../../services/aliyun/aliyun.service';
import {ChosenPluginsComponent} from '../chosen-plugins/chosen-plugins.component';

@Component({
  selector: 'bw-image-cropper-plugins',
  templateUrl: './image-cropper-plugins.component.html',
  styleUrls: ['./image-cropper-plugins.component.scss']
})
export class ImageCropperPluginsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('proRef') proRef: ChosenPluginsComponent;
  @Input() inputOptions;
  subscription: any;
  image: {};
  url1: string;
  modalEle: {};
  imgEle: {};
  inputEle: {};
  imgPro = 2;
  isShow = false;
  proOpt = {
    valueObj: {
      chosenValue: NaN,
    },
    chosenItem: {
      isMultiple: false,
      is_chosen_rtl: false,
      isNO: false,
      chosenOption: [
        {value: 2, name: '2/1'},
        {value: 1, name: '1/1'},
        {value: NaN, name: '任意'}
      ]
    }
  };

  constructor (private aliyunService: AliyunService, private sanitization: DomSanitizer, private elementRef: ElementRef) {
  }

  ngAfterViewInit () {
    this.modalEle = this.elementRef.nativeElement.querySelector('div');
    this.imgEle = this.elementRef.nativeElement.querySelector('img');
    this.inputEle = this.elementRef.nativeElement.querySelector('input');
    this.initCropper();
    $(this.modalEle).on('show.bs.modal', () => {
      this.isShow = true;
      $(this.imgEle).cropper('replace', this.inputOptions.value);
      this.imgPro = isNullOrUndefined(this.inputOptions.imgPro) ? NaN : this.inputOptions.imgPro;
      this.proOpt.valueObj.chosenValue = this.imgPro;
      setTimeout(() => {
        this.elementRef.nativeElement.querySelector('.chosen-container').style.width = '350px';
        this.proRef.plugins.trigger('chosen:updated');
        this.proRef.setChoosed(this.imgPro);
      });
      this.updateAspectRatio(this.imgPro);
    });

    // $(this.elementRef.nativeElement.querySelector('.chosen-select')).on('change', () => {
    //   this.imgPro = parseInt($(this.elementRef.nativeElement.querySelector('.chosen-select')).val());
    //   this.updateAspectRatio(this.imgPro);
    // })

  }
  getPro (e) {
    this.imgPro = parseInt(e, 0);
    this.updateAspectRatio(this.imgPro);
  }

  ngOnInit () {
    this.image = this.sanitization.bypassSecurityTrustUrl(this.inputOptions.value);
    this.subscription = this.aliyunService.engineStatus.subscribe((res: any) => {
      if (res) {
        this.url1 = this.aliyunService.getUrlForBase64();
        $(this.modalEle).modal('hide');
      } else {
        // console.error('AliyunService request error!!!');
        $(this.modalEle).modal('hide');
      }
    });
  }

  ngOnDestroy () {
    if (!isNullOrUndefined(this.subscription)) {
      this.subscription.unsubscribe();
    }
  }

  updateAspectRatio (num: number) {
    $(this.imgEle).cropper('setAspectRatio', num);
  }

  initCropper () {
    $(this.imgEle).cropper({
      aspectRatio: this.imgPro,
      modal: false,
      autoCropArea: 1,
      crop: function (e) {
      },
      ready: function () {
        $(this.imgEle).cropper('replace');
      }
    });
  }

  chooseImage () {
    $(this.inputEle).trigger('click');
  }

  upload (e) {
    const file: {} = e.srcElement.files[0];
    const url: string = URL.createObjectURL(file);
    this.image = this.sanitization.bypassSecurityTrustUrl(url);
    $(this.imgEle).cropper('replace', url);
    $(this.elementRef.nativeElement.querySelector('.upload-input')).val('');
  }

  rotateLeft () {
    $(this.imgEle).cropper('rotate', -1);
  }

  rotateRight () {
    $(this.imgEle).cropper('rotate', 1);
  }

  cropperReset () {
    $(this.imgEle).cropper('reset');
  }

  imageUpload () {
    $(this.imgEle).cropper('getCroppedCanvas', {
      width: $(this.imgEle).cropper('getData').width, height: $(this.imgEle).cropper('getData').height
    }).toBlob(blob => {
      const readBlobAsDataURL: Function = (blob1, callback) => {
        const a = new FileReader();
        a.onload = function (e) {
          callback(e.target['result']);
        };
        a.readAsDataURL(blob1);
      };

      readBlobAsDataURL(blob, dataurl => {
        let arr: any[];
        if ($(this.inputEle)[0].value) {
          arr = $(this.inputEle)[0].value.split('.');
        } else {
          arr = this.inputOptions.value.split('.');
        }
        this.aliyunService.uploadImageForBase64(dataurl, arr[arr.length - 1], this.inputOptions.cName);
      });
    });
  }
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/components/image-cropper-plugins/image-cropper-plugins.component.ts